import { removeArrayElement } from "../../../utils/general";
import {
    ADD_TENANT, DELETE_TENANT, FETCH_TENANTS, LOG_OUT_USER
} from '../../actions/actionTypes';


const fetchTenantsReducer = (tenants, payload) => {
    let newTenants = payload.appendData ? [...tenants] : [];
    let tenantsMap = {};
    for(let t of Object.values(payload.tenants)){
        if(!(t.tenantId in tenantsMap)){
            tenantsMap[t.tenantId] = t;
            newTenants.push(t.tenantId);
        }  
    }
    let uniqueIds = [...new Set(newTenants)];
    return uniqueIds;
}

const addTenantReducer = (tenants, payload) => {
    let newTenants = tenants && tenants.length > 0? [ ...tenants ]: [];
    newTenants.unshift(payload.tenantId)
    return newTenants;
}

const deleteTenantReducer = (tenants, payload) => {
    let newTenants = [ ...tenants ];
    let remainingTenants = removeArrayElement(newTenants, payload.tenantId)
    return remainingTenants;
}


const tenantsOrderReducer = (state=[], action) => {
    let tenants = state;
    if (action.errors == null){
        switch(action.type){
            case FETCH_TENANTS:
                return fetchTenantsReducer(tenants, action.payload);
            case ADD_TENANT:
                return addTenantReducer(tenants, action.payload);
            case DELETE_TENANT:
                return deleteTenantReducer(tenants, action.payload);
            case LOG_OUT_USER:
                return {};
            default:
                return tenants;
        }
    }else{
        return tenants;
    }
};

export default tenantsOrderReducer;